export default {
    namespaced: true,
    state: {
        data: {},
        error: false,
        loading: false,
    },
    mutations: {
        setData: (state, data) => (state.data = data),
        setError: (state, error) => (state.error = error),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
    },
    actions: {
        fetchAccounts: ({ commit }, data) => {
            commit("loadingProcess");
            return axios
                .get(`/admin/accounts/etp`)
                .then(res => {
                    commit("removeError");
                    commit("setData", res.data);
                })
                .catch(err => {
                    commit("setError", err.response.data.message ?? err.message ?? "Неизвестная ошибка");
                    console.error(err);
                })
                .finally(() => commit("loadingCompleted"));
        },
        downloadETPData: ({ commit }, data) => {
            const { token, params } = data;
            const url = `/admin/accounts/downloadReport`;
            return axios
                .get(url, {
                    params,
                })
                .then(res => {
                    return res.data;
                });
        },
        downloadETPDepositData: ({ commit }, data) => {
            const { token, params } = data;
            const url = `/admin/accounts/downloadDepositReport`;
            return axios
                .get(url, {
                    params,
                })
                .then(res => {
                    return res.data;
                });
        },

        refillByInn: ({ commit }, data) => {
            const url = `/admin/accounts/refillByInn`;
            return axios.post(url, {
                summ: data.sum,
                comment: data.comment,
                inn: data.inn,
            });
        },

        withdrawByInn: ({ commit }, data) => {
            const url = `/admin/accounts/withdrawByInn`;
            return axios.post(url, {
                summ: data.sum,
                comment: data.comment,
                inn: data.inn,
            });
        },
    },
};
